<div class="background px-3">
    <div class="d-flex justify-content-center">
      <div class="card p-4 w-100" style="max-width: 1200px;">
  
        <div class="row">
            <h3 class="col">Registracija Kmetije</h3>   
        </div>

            <!-- Step Control -->

                <!-- Step 1: Farm Info -->
                <div [hidden]="currentStep != 'farmInfo'">
                <div class="container">
                    <div class="row">
                    <!-- Form Details Column -->
                    <div class="col-md-6">
                        <form [formGroup]="farmInfoFormGroup">
                        <!-- Farm Details -->
                        <label class="ms-4 mt-3 mb-2" for="farmNameInput">Ime kmetije <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faHome"></fa-icon>
                            <input id="farmNameInput" class="form-control me-3" type="text" formControlName="farmName" placeholder="Vnesi ime kmetije">
                        </div>
                        <span *ngIf="farmName?.dirty && farmName?.errors?.['required']" class="row ms-4 mt-1">Ime kmetije je zahtevano.</span>
            
                        <label class="ms-4 mt-3 mb-2" for="farmAddressInput">Fizični naslov <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faAddressBook"></fa-icon>
                            <input id="farmAddressInput" class="form-control me-3" type="text" formControlName="farmAddress" placeholder="Ulica in hišna številka, pošta">
                        </div>
                        <span *ngIf="farmAddress?.dirty && farmAddress?.errors?.['required']" class="row ms-4 mt-1">Fizični naslov je zahtevan.</span>
            
                        <label class="ms-4 mt-3 mb-2" for="farmPhoneInput">Telefon <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faPhone"></fa-icon>
                            <input id="farmPhoneInput" class="form-control me-3" type="tel" formControlName="farmPhone" pattern="[0-9]{3}[\\s|\\-]?[0-9]{3}[\\s|\\-]?[0-9]{3}" placeholder="012345678">
                        </div>
                        <span *ngIf="farmPhone?.dirty && farmPhone?.errors?.['required']" class="row ms-4 mt-1">Telefonska številka je zahtevana.</span>
            
                        <label class="ms-4 mt-3 mb-2" for="farmEmailInput">Elektronski naslov <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faEnvelope"></fa-icon>
                            <input id="farmEmailInput" class="form-control me-3" type="email" formControlName="farmEmail" placeholder="mojnaslov@posta.xx" pattern="^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$">
                        </div>
                        <span *ngIf="farmEmail?.dirty && farmEmail?.errors?.['required']" class="row ms-4 mt-1">Elektronski naslov je zahtevan.</span>
            
                        <label class="ms-4 mt-3 mb-2" for="farmDescriptionInput">Opis kmetije</label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faInfoCircle"></fa-icon>
                            <textarea id="farmDescriptionInput" class="form-control me-3" formControlName="farmDescription" placeholder="Vnesi opis kmetije"></textarea>
                        </div>
                        
                    </form>
                    </div>
            
                    <!-- Map Column -->
                    <div class="col-md-6">
                        <app-map (locationSelected)="handleLocationSelected($event)"></app-map>
                    </div>
                    <!-- Proceed Button -->
                     <div class="d-flex justify-content-start">
                         <button type="button" class="btn custom-button" (click)="proceedToEmployees()" [disabled]="farmInfoFormGroup.invalid" style="width: auto; white-space: nowrap;">
                            Nadaljuj<fa-icon class="ms-2" [icon]="faArrowRight"></fa-icon></button>
                     </div>
                    </div>
                </div>
            </div>
  

            <!-- Step 2: Employees -->
            <div *ngIf="currentStep == 'employees'">
                <h4 class="ms-4 mt-3 mb-2">Zaposleni</h4>
                <form [formGroup]="employeesFormGroup">
                    <div class="row" formArrayName="employees">
                        <div class="col-md-4 mb-3" *ngFor="let employee of employees.controls; let i=index" [formGroupName]="i">
                            <div class="employee-form p-2 border rounded">
                                <label for="employeeNameInput{{i}}">Ime zaposlenega <span class="text-danger">*</span></label>
                                <input id="employeeNameInput{{i}}" class="form-control mb-2" type="text" formControlName="name" placeholder="Ime">
            
                                <label for="employeeSurnameInput{{i}}">Priimek zaposlenega <span class="text-danger">*</span></label>
                                <input id="employeeSurnameInput{{i}}" class="form-control mb-2" type="text" formControlName="surname" placeholder="Priimek">
            
                                <label for="employeeDescriptionInput{{i}}">Opis zaposlenega</label>
                                <textarea id="employeeDescriptionInput{{i}}" class="form-control mb-2" formControlName="employeeDescription" placeholder="Opis"></textarea>
            
                                <button type="button" class="btn btn-danger mb-2" (click)="removeEmployee(i)">
                                    Odstrani<fa-icon class="ms-2" [icon]="faTrash"></fa-icon></button>
                            </div>
                        </div>
                        <button type="button" class="btn custom-button-add mb-3" (click)="addEmployee()"><fa-icon class="me-2" [icon]="faPlus"></fa-icon>Dodaj zaposlenega</button>
                    </div>
            
                    <!-- Proceed Button -->
                    <button type="button" class="btn custom-button me-2" (click)="goBackToFarmInfo()">
                        <fa-icon class="me-2" [icon]="faArrowLeft"></fa-icon>Nazaj</button>
                    <button type="button" class="btn custom-button" (click)="proceedToProducts()" [disabled]="employeesFormGroup.invalid">
                        Nadaljuj<fa-icon class="ms-2" [icon]="faArrowRight"></fa-icon></button>
                </form>
            </div>
            

            <!-- Step 3: Products -->
            <div *ngIf="currentStep == 'products'">
                <h4 class="ms-4 mt-3 mb-2">Izdelki - dodajte najmanj enega (slike lahko dodajate kasneje)</h4>
                <form [formGroup]="productsFormGroup">
                    <div class="row" formArrayName="products">
                        <div class="col-md-4 mb-3" *ngFor="let product of products.controls; let i=index" [formGroupName]="i">
                            <div class="product-form p-2 border rounded">
                                <label for="productNameInput{{i}}">Ime izdelka <span class="text-danger">*</span></label>
                                <input id="productNameInput{{i}}" class="form-control mb-2" type="text" formControlName="name" placeholder="Ime izdelka">
                                <span *ngIf="product.get('name')?.dirty && product.get('name')?.errors?.['required']" class="text-danger">Ime izdelka je zahtevano.</span>
            
                                <label for="productDescriptionInput{{i}}">Opis izdelka</label>
                                <textarea id="productDescriptionInput{{i}}" class="form-control mb-2" formControlName="description" placeholder="Opis izdelka"></textarea>
            
                                <label for="productTypeInput{{i}}">Tip izdelka <span class="text-danger">*</span></label>
                                <select id="productTypeInput{{i}}" class="form-control mb-2" formControlName="type">
                                  <option *ngFor="let type of productTypes" [value]="type">{{ type }}</option>
                                </select>
                                <span *ngIf="product.get('type')?.dirty && product.get('type')?.errors?.['required']" class="text-danger">Tip izdelka je zahtevan.</span>                                
            
                                <button type="button" class="btn btn-danger mb-2" (click)="removeProduct(i)">
                                    Odstrani<fa-icon class="ms-2" [icon]="faTrash"></fa-icon></button>
                            </div>
                        </div>
                            <button type="button" class="btn custom-button-add ms-4 mb-3" (click)="addProduct()"><fa-icon class="me-2" [icon]="faPlus"></fa-icon>Dodaj izdelek</button>
                    </div>
            
                    <!-- Finish Button -->
                    <button type="button" class="btn custom-button" (click)="goBackToEmployees()">
                        <fa-icon class="me-2" [icon]="faArrowLeft"></fa-icon>Nazaj</button>
                    <button type="button" class="btn custom-button" (click)="finishRegistration()" [disabled]="productsFormGroup.invalid">Registriraj Kmetijo</button>
                </form>
            </div>
            
        </div>
    </div>
</div>